// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".item[data-v-6e333306]{font-size:16px;line-height:20px;color:#200033;padding:11px 18px;display:block;text-decoration:none}.item[data-v-6e333306]:hover{background:#f2f2ff}.item[data-v-6e333306]:first-child{border-top-right-radius:12px;border-top-left-radius:12px}.item[data-v-6e333306]:last-child{border-bottom-right-radius:12px;border-bottom-left-radius:12px}", ""]);
// Exports
module.exports = exports;
